// extracted by mini-css-extract-plugin
export default {"Container":"FbGroups_Container__wkwcQ"};